import React from 'react';
import { ShieldCheckIcon, CheckIcon } from 'lucide-react';
import { SectionCta } from '../components/SectionCta';
const steps = ['Review the volumes', 'Explore the protocols', 'Use the checklists', 'Go through the visual frameworks'];
export function Guarantee() {
  return <section className="w-full bg-white py-14 sm:py-20" aria-labelledby="guarantee-heading" data-id="element-195" data-mp="1my5s1myo381g">
      <div className="mx-auto w-full max-w-3xl px-4 sm:px-6" data-id="element-196" data-mp="21vogeo7fnj8d">
        <div className="rounded-2xl border-2 border-emerald-500/40 bg-emerald-50/60 p-5 sm:p-8" data-id="element-197" data-mp="21u3gsk69ha3n">
          <div className="flex items-center gap-3" data-id="element-198" data-mp="1wwlaz2njjazv">
            <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-emerald-600" data-id="element-199" data-mp="2aohvolmvqim8">
              <ShieldCheckIcon aria-hidden="true" className="h-6 w-6 text-white" data-id="element-200" data-mp="26npodxxkinsl" />
            </span>
            <div data-id="element-201" data-mp="2knh6oav4aqce">
              <p className="text-[11px] font-bold uppercase tracking-[0.16em] text-emerald-700" data-id="element-202" data-mp="2kmxm0me31nuo">
                Your 7-day guarantee
              </p>
              <h2 id="guarantee-heading" className="mt-1 font-display text-[20px] font-extrabold leading-tight tracking-tight text-navy-900 sm:text-[26px]" data-id="element-203" data-mp="2f6sm51fz2vrm">
                Try the System completely risk-free
              </h2>
            </div>
          </div>

          <p className="mt-5 text-[15px] leading-relaxed text-ink-700" data-id="element-204" data-mp="2t6jxsvj0o02g">
            We want you to feel confident about your decision. That’s why you have 7 full days
            to explore the Aligner Planning Master System™.
          </p>

          <ul className="mt-5 grid gap-2.5 sm:grid-cols-2" data-id="element-205" data-mp="332dhcyv5kttq">
            {steps.map(step => <li key={step} className="flex items-start gap-2.5" data-id="element-206" data-mp="37vq413g9uqju">
                <CheckIcon aria-hidden="true" className="mt-[3px] h-4 w-4 shrink-0 text-emerald-600" data-id="element-207" data-mp="3cszpy94gck2x" />
                <span className="text-[14px] font-medium leading-snug text-navy-900" data-id="element-208" data-mp="3gts0r6sz2x1b">
                  {step}
                </span>
              </li>)}
          </ul>

          <p className="mt-5 text-[15px] leading-relaxed text-ink-700" data-id="element-209" data-mp="1lsq0hnrqq3ro">
            If you don’t believe the System provides useful clinical planning resources and
            meets your expectations, simply contact us within 7 days and request a refund. No
            complicated process. No unnecessary questions. Just a straightforward 7-day
            guarantee.
          </p>
        </div>

        <SectionCta label="Try it risk-free for 7 days" data-id="element-210" data-mp="25embhmvco3f6" />
      </div>
    </section>;
}